/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbClauseDto
 */
export interface FcbClauseDto {
    /**
     * 
     * @type {number}
     * @memberof FcbClauseDto
     */
    idclause?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbClauseDto
     */
    idstade?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbClauseDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbClauseDto
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbClauseDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbClauseDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbClauseDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbClauseDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbClauseDto
     */
    idclauseGuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbClauseDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbClauseDto interface.
 */
export function instanceOfFcbClauseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClauseDtoFromJSON(json: any): FcbClauseDto {
    return FcbClauseDtoFromJSONTyped(json, false);
}

export function FcbClauseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClauseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idclause': !exists(json, 'idclause') ? undefined : json['idclause'],
        'idstade': !exists(json, 'idstade') ? undefined : json['idstade'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'idclauseGuid': !exists(json, 'idclauseGuid') ? undefined : json['idclauseGuid'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbClauseDtoToJSON(value?: FcbClauseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idclause': value.idclause,
        'idstade': value.idstade,
        'description': value.description,
        'title': value.title,
        'creationUser': value.creationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'idclauseGuid': value.idclauseGuid,
        'actif': value.actif,
    };
}

